import { media } from "@universityofmaryland/web-token-library";
import { objectWithClassName } from "../../utilities/create/jss.js";
import "../../node_modules/postcss/lib/postcss.js";
import "../../node_modules/postcss-js/index.js";
import "../../node_modules/postcss-nesting/dist/index.js";
import "../../_virtual/index.js";
const classNamePrefix = "umd-layout-grid-child";
const sizeDouble = objectWithClassName({
  [`@media (${media.queries.large.min})`]: {
    gridColumn: "span 2"
  },
  className: [
    `${classNamePrefix}-size-double`,
    /** @deprecated Use 'umd-layout-grid-child-size-double' instead */
    "umd-grid-column-double"
  ]
});
const startSecond = objectWithClassName({
  [`@media (${media.queries.highDef.min})`]: {
    gridColumnStart: "2"
  },
  className: `${classNamePrefix}-start-second`
});
const fillHeight = objectWithClassName({
  [`@media (${media.queries.tablet.min})`]: {
    ["&, & > *"]: {
      height: "100%"
    }
  },
  className: `${classNamePrefix}-fill-height`
});
export {
  fillHeight,
  sizeDouble,
  startSecond
};
//# sourceMappingURL=child.js.map
